const FETCH_BONUSES = 'fetch_bonuses';
const FETCH_BONUSES_CSV = 'fetch_bonuses_csv';

const FETCH_BONUS = 'fetch_bonus';
const GENERATE_BONUS = 'generate_bonus';
const FETCH_EXIGENT_BONUS_STATUS = 'fetch_exigent_bonus_status';
const RESET_EXIGENT_BONUS_STATUS = 'reset_exigent_bonus_status';
export default {
    FETCH_BONUSES,
    FETCH_BONUSES_CSV,
    FETCH_BONUS,
    GENERATE_BONUS,
    FETCH_EXIGENT_BONUS_STATUS,
    RESET_EXIGENT_BONUS_STATUS,
};
